<template>
  <app-content class="h-panel">
    <Loading text="数据加载中..." :loading="loading"></Loading>
    <div class="h-panel-bar">
      <span class="h-panel-title">报表快照</span>
      <Button class="float-right" @click="$router.push({ name: 'ReportList' })">返回报表</Button>
      <Button class="float-right margin-right" color="primary" @click="$router.push({ name: 'ReportSnapshotGenerate' })">
        生成快照
      </Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="dataList" border>
        <TableItem title="标题" prop="title"></TableItem>
        <TableItem title="备注">
          <template slot-scope="{ data }">
            <span>{{ data.remark || '-' }}</span>
          </template>
        </TableItem>
        <TableItem title="快照编号" prop="snapshotNo"></TableItem>
        <TableItem title="会计期间">
          <template slot-scope="{ data }">
            {{ formatDate(data.accountDate) }}
          </template>
        </TableItem>
        <TableItem title="创建人" prop="createdByName"></TableItem>
        <TableItem title="创建时间">
          <template slot-scope="{ data }">
            {{ formatDateTime(data.createTime) }}
          </template>
        </TableItem>
        <TableItem title="分享状态">
          <template slot-scope="{ data }">
            <span v-if="data.hasShare" class="green-color">
              已分享（{{ data.shareAccessMode === 'PASSWORD' ? '密码' : '公开' }}）
            </span>
            <span v-else class="gray-color">未分享</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="220" align="center">
          <template slot-scope="{ data }">
            <span class="link" @click="viewDetail(data)">查看</span>
            <span class="link margin-left" v-if="data.hasShare" @click="copyShareLink(data)">复制链接</span>
          </template>
        </TableItem>
      </Table>
      <div class="empty-tip" v-if="!loading && dataList.length === 0">暂无快照，点击“生成快照”创建。</div>
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'ReportSnapshotList',
  data() {
    return {
      loading: false,
      dataList: []
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.report.snapshot.list().then(({ data }) => {
        this.dataList = data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    viewDetail(row) {
      this.$router.push({ name: 'ReportSnapshotDetail', params: { snapshotId: row.id } });
    },
    copyShareLink(row) {
      const sharePath = row.shareUrlPath || (row.shareToken ? `/report/snapshot/share/${row.shareToken}` : '');
      if (!sharePath) {
        this.$Message.error('该快照未生成分享链接');
        return;
      }
      const shareLink = `${window.location.origin}${sharePath}`;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareLink).then(() => {
          this.$Message.success('分享链接已复制');
        }).catch(() => {
          this.fallbackCopy(shareLink);
        });
      } else {
        this.fallbackCopy(shareLink);
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$Message.success('分享链接已复制');
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
    },
    formatDateTime(date) {
      if (!date) return '-';
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      return `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())} ${this.pad(d.getHours())}:${this.pad(d.getMinutes())}`;
    },
    pad(n) {
      return n < 10 ? `0${n}` : `${n}`;
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style scoped>
.margin-right {
  margin-right: 10px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
}
.margin-left {
  margin-left: 10px;
}
.empty-tip {
  margin-top: 12px;
  color: #999;
}
</style>
